export const convertISOToDatePicker = (value) => {
    const datePattern = /^(\d{4})-(\d{2})-(\d{2})$/;
    const [candidate] = value.split('T');
    if (!datePattern.test(candidate)) {
        return candidate;
    }
    return candidate.replace(datePattern, '$3.$2.$1');
};
export const convertDatePickerToISO = (value) => {
    const datePattern = /^(\d{2})\.(\d{2})\.(\d{4})$/;
    if (!datePattern.test(value)) {
        return value;
    }
    return value.replace(datePattern, '$3-$2-$1');
};
